/**
 * Area Choice modal controller.
 *
 * This class controls the Welcome Office theme's Area Choice modal.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class AreaChoiceModal
 */
 class AreaChoiceModal {

	/**
     * Class constructor is for binding class properties.
     */
	constructor() {
	}

	/**
	 * Cache dom elements for use in the class's methods
	 */
	cache() {
		this.areaModals  = $(".area-choice-modal-btn");
		this.areaChoices = $(".area-choices");

		// Cache string to control close the modal and an aria description
		this.closeGalleryString  = themeData.themeStrings.close;
		this.dialogWindowString  = themeData.themeStrings.dialog_window;
	}

	/**
     * All common events
     * @return {void}
     */
	events() {

		let closeGalleryString = this.closeGalleryString;
		let dialogWindowString = this.dialogWindowString;

		this.areaModals.each( function() {
			$( this ).modaal({
				close_text: closeGalleryString, // eslint-disable-line
				close_aria_label: dialogWindowString, // eslint-disable-line
				content_source: $( this ).data( 'modaal-content-source' ), // eslint-disable-line
			});
		});

		this.areaChoices.each( function() {			
			this.addEventListener( 'change', ( e ) => {
				const areaChoiceSubmit = document.getElementById( e.target.dataset.submit );
				areaChoiceSubmit.setAttribute( 'href', `${e.target.value}` );
			});
		});
	}

	/**
     * Run when the document is ready.
     */
	docReady() {
		this.cache();
		this.events();
	}
}

// Export the class reference.
module.exports = new AreaChoiceModal();



// WEBPACK FOOTER //
// ./assets/scripts/area-choice-modal.js